export default function (object, schema) {
    if (!object) {
        return false;
    }
    return schema.every((key) => object[key] !== undefined);
}
